import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TranslocoDirective } from '@jsverse/transloco';
import { DeliveryDestinations } from '../../../../interfaces/deliveryDestionations.model';

@Component({
  selector: 'cus-customers-edit-address-details-dialog-component',
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    TranslocoDirective,
  ],
  templateUrl: './customers-edit-address-details-dialog-component.html',
  styleUrl: './customers-edit-address-details-dialog-component.scss',
})
export class CustomersEditAddressDetailsDialogComponent {
  editAddressForm: FormGroup;

  constructor(
    private dialogRef: MatDialogRef<CustomersEditAddressDetailsDialogComponent>,
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) readonly data: DeliveryDestinations,
  ) {
    this.editAddressForm = this.formBuilder.group({
      riferimento: [data.riferimento ?? ''],
      nota: [data.nota.notaLibera ?? ''],
      giorni: [data.nota.giorni ?? ''],
      orari: [data.nota.orari ?? ''],
      contatto: [data.nota.contatto ?? ''],
      sponda: [data.nota.sponda],
    });
  }

  onClose() {
    this.dialogRef.close();
  }

  onReset() {
    this.editAddressForm.reset({
      riferimento: this.data.riferimento ?? '',
      nota: this.data.nota.notaLibera ?? '',
      giorni: this.data.nota.giorni ?? '',
      orari: this.data.nota.orari ?? '',
      contatto: this.data.nota.contatto ?? '',
      sponda: this.data.nota.sponda,
    });
  }

  onApply() {
    this.dialogRef.close(this.editAddressForm.getRawValue());
  }
}
